import React, { useState } from "react";
import {
  FaUsers,
  FaComments,
  FaUserPlus,
  FaExclamationTriangle,
} from "react-icons/fa";
import { LuUsers } from "react-icons/lu";
import { PiChats } from "react-icons/pi";
import { TbUserScan } from "react-icons/tb";
import { LiaUserTimesSolid } from "react-icons/lia";
import { IoIosTrendingDown } from "react-icons/io";
import { IoIosTrendingUp } from "react-icons/io";
import { useNavigate } from "react-router-dom";

export default function DashboardCards({ cardData }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ">
      <div
        className={`stats border rounded-md border-[#EBEBEB] cursor-pointer transition-colors duration-200 ${
          activeIndex == 0
            ? "bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)] rounded-md text-white"
            : "bg-white"
        }`}
        onClick={() => {
          setActiveIndex(0);
          navigate("/admin/userslist");
        }}
      >
        <div className="stat">
          <div className="flex items-center gap-2.5">
            <div
              className={`stat-title rounded-md h-[38px] w-[38px] flex justify-center items-center gap-2 ${
                activeIndex == 0
                  ? "bg-white text-blue-600"
                  : "bg-[#F9F7FF] text-black"
              }`}
            >
              <LuUsers
                size={22}
                className={
                  activeIndex == 0
                    ? "text-black"
                    : "text-[var(--primary-color)]"
                }
              />
            </div>
            <div
              className={`stat-title text-md font-medium flex items-center gap-2 ${
                activeIndex == 0 ? "text-white" : "text-[#525252]"
              }`}
            >
              Total Users
            </div>
          </div>
          <div className="flex items-center gap-3 pt-3">
            <div className="stat-value text-2xl font-semibold">
              {cardData?.totalUsers}
            </div>
            {/* <div
                  className={`stat-desc flex items-center gap-1 text-xs p-2 py-1 rounded-md ${
                    activeIndex == 0
                      ? "bg-white"
                      : changePositive
                      ? "bg-[#E6F5EC]"
                      : "bg-[#FFEFEE]"
                  } ${changePositive ? "text-green-500" : "text-red-500"}`}
                >
                  {changePositive ? <IoIosTrendingUp /> : <IoIosTrendingDown />}{" "}
                  {stat.change.replace("-", "")}
                </div> */}
          </div>
        </div>
      </div>
      <div
        className={`stats border rounded-md border-[#EBEBEB] cursor-pointer transition-colors duration-200 ${
          activeIndex == 1
            ? "bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)] rounded-md text-white"
            : "bg-white"
        }`}
        onClick={() => {
          setActiveIndex(1);
          navigate("/admin/blockedusers");
        }}
      >
        <div className="stat">
          <div className="flex items-center gap-2.5">
            <div
              className={`stat-title rounded-md h-[38px] w-[38px] flex justify-center items-center gap-2 ${
                activeIndex == 1
                  ? "bg-white text-blue-600"
                  : "bg-[#F9F7FF] text-black"
              }`}
            >
              <LiaUserTimesSolid
                size={22}
                className={
                  activeIndex == 1
                    ? "text-black"
                    : "text-[var(--primary-color)]"
                }
              />
            </div>
            <div
              className={`stat-title text-md font-medium flex items-center gap-2 ${
                activeIndex == 1 ? "text-white" : "text-[#525252]"
              }`}
            >
              Blocked Users
            </div>
          </div>
          <div className="flex items-center gap-3 pt-3">
            <div className="stat-value text-2xl font-semibold">
              {cardData?.totalBlockedUsers}
            </div>
            {/* <div
                  className={`stat-desc flex items-center gap-1 text-xs p-2 py-1 rounded-md ${
                    activeIndex == 0
                      ? "bg-white"
                      : changePositive
                      ? "bg-[#E6F5EC]"
                      : "bg-[#FFEFEE]"
                  } ${changePositive ? "text-green-500" : "text-red-500"}`}
                >
                  {changePositive ? <IoIosTrendingUp /> : <IoIosTrendingDown />}{" "}
                  {stat.change.replace("-", "")}
                </div> */}
          </div>
        </div>
      </div>
      <div
        className={`stats border rounded-md border-[#EBEBEB] cursor-pointer transition-colors duration-200 ${
          activeIndex == 2
            ? "bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)] rounded-md text-white"
            : "bg-white"
        }`}
        onClick={() => setActiveIndex(2)}
      >
        <div className="stat">
          <div className="flex items-center gap-2.5">
            <div
              className={`stat-title rounded-md h-[38px] w-[38px] flex justify-center items-center gap-2 ${
                activeIndex == 2
                  ? "bg-white text-blue-600"
                  : "bg-[#F9F7FF] text-black"
              }`}
            >
              <PiChats
                size={22}
                className={
                  activeIndex == 2
                    ? "text-black"
                    : "text-[var(--primary-color)]"
                }
              />
            </div>
            <div
              className={`stat-title text-md font-medium flex items-center gap-2 ${
                activeIndex == 2 ? "text-white" : "text-[#525252]"
              }`}
            >
              Active Chats
            </div>
          </div>
          <div className="flex items-center gap-3 pt-3">
            <div className="stat-value text-2xl font-semibold">
              {cardData?.totalChats}
            </div>
            {/* <div
                  className={`stat-desc flex items-center gap-1 text-xs p-2 py-1 rounded-md ${
                    activeIndex == 0
                      ? "bg-white"
                      : changePositive
                      ? "bg-[#E6F5EC]"
                      : "bg-[#FFEFEE]"
                  } ${changePositive ? "text-green-500" : "text-red-500"}`}
                >
                  {changePositive ? <IoIosTrendingUp /> : <IoIosTrendingDown />}{" "}
                  {stat.change.replace("-", "")}
                </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
